import React, { useState } from 'react';
import ValidationResult from '@common/interfaces/api/validation-result';
import { useTranslation } from 'react-i18next';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import InputLabel from '@mui/material/InputLabel';
import Select, { BaseSelectProps } from '@mui/material/Select';
import { useTheme } from '@mui/material';
import { useAppSelector } from '../../store';
import { selectIsUserAdminOrHigher } from '../../store/general/general-slice-selectors';

interface CustomSelectProps extends BaseSelectProps {
  validationResult?: ValidationResult;
  adminOnly?: boolean;
  hideHelpText?: boolean;
  fullWidth?: boolean;
}

const SelectInput: React.FC<CustomSelectProps> = ({
  label,
  children,
  variant,
  validationResult,
  adminOnly,
  hideHelpText,
  disabled,
  onBlur,
  fullWidth = true,
  ...props
}) => {
  const { t } = useTranslation();
  const theme = useTheme();

  const isAdmin = useAppSelector((state) => selectIsUserAdminOrHigher(state));

  const [startValue] = useState(props.value);

  const labelId = ('select-helper-label' + label).replace(/ /g, '');

  return (
    <FormControl fullWidth={fullWidth} variant={variant}>
      <InputLabel id={labelId}>{label}</InputLabel>
      <Select
        {...props}
        onBlur={(event) =>
          startValue !== props.value && onBlur != null ? onBlur(event) : undefined
        }
        label={label}
        disabled={disabled || (!isAdmin && adminOnly)}
        labelId={labelId}
        error={validationResult !== undefined && !validationResult.isValid}
      >
        {children}
      </Select>
      {hideHelpText !== true &&
        validationResult !== undefined &&
        validationResult.error !== null && (
          <FormHelperText
            sx={{ color: validationResult.isValid === true ? 'default' : theme.palette.error.main }}
          >
            {t(validationResult.error)}
          </FormHelperText>
        )}
    </FormControl>
  );
};

export default SelectInput;
